export default {
  getInformation (state) {
    return state.admin
  },
  getToken (state) {
    return state.admin._token
  }
}